import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface UserState {
  username: string | null;
  email: string | null;
  token: string | null;
}

const initialState: UserState = {
  username: null,
  email: null,
  token: null,
};

export const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{
        user: { username: string; email: string };
        jwt: string;
      }>
    ) => {
      state.username = action.payload.user.username;
      state.email = action.payload.user.email;
      state.token = action.payload.jwt;
    },
    logout: (state) => {
      state.username = null;
      state.email = null;
      state.token = null;
    },
  },
});


// Action creators are generated for each case reducer function
export const { login, logout } = userSlice.actions

export default userSlice.reducer